import {
  ChangeDetectionStrategy,
  Component,
  output,
  signal,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PuebloBase } from '@components/pueblo-base.component';

@Component({
  selector: 'display-name-form',
  templateUrl: 'display-name-form.component.html',
  styleUrl: 'display-name-form.component.scss',
  imports: [
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayNameForm extends PuebloBase {
  protected readonly loading = signal(false);
  protected readonly nameChosen = output<string>();

  protected displayNameChosen(displayName: string): void {
    this.loading.set(true);
    this.nameChosen.emit(displayName);
  }
}
